<template>
  <div class="order-details">
    <h1>Order Details</h1>
    <div v-if="loading">Loading order details...</div>
    <div v-else-if="error" class="error">{{ error }}</div>
    <div v-else>
      <p><strong>Order Reference:</strong> {{ order.reference }}</p>
      <p><strong>Date:</strong> {{ formatDate(order.system_date) }}</p>
      <p><strong>Total Value:</strong> {{ order.total_order_value }}</p>
      <p><strong>Status:</strong> {{ order.order_approval_status }}</p>

      <h2>Items</h2>
      <ul>
        <li v-for="item in order.items" :key="item.id">
          {{ item.name }} - {{ item.quantity }} x {{ item.price }}
        </li>
      </ul>

      <div class="row">
        <div class="col-12">
          <div>
            <div class="table-content table-responsive">
              <table class="table">
                <thead>
                  <tr>
                    <th class="product-thumbnail">Images</th>
                    <th class="cart-product-name">Product</th>
                    <th class="product-price">Unit Price</th>
                    <th class="product-quantity">Quantity</th>
                    <th class="product-subtotal">Total</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in orderItems" :key="item.id">
                    <td class="product-thumbnail">
                        <img :src="item.image_url" alt="">
                    </td>
                    <td class="product-name">
                      {{ item.product_name }}
                    </td>
                    <td class="product-price">
                      <span class="amount">LKR {{ item.product_price }}</span>
                    </td>
                    <td class="product-quantity">
                      <div class="cart-plus-minus">
                        <span class="amount">{{ item.product_qty }}</span>
                        
                      </div>
                    </td>
                    <td class="product-subtotal" v-if="item.product_qty">
                      <span class="amount">LKR {{ item.total_gross_value }}</span>
                    </td>
                    
                  </tr>
                </tbody>
              </table>
            </div>
          
            <div class="row justify-content-end">
              <div class="col-md-5">
                <div class="cart-page-total">
                  <h2>Cart totals</h2>
                  <ul class="mb-20">
                    <li>Total 
                      <span>LKR {{ order.total_order_value }}</span>
                    </li>
                  </ul>
                  <router-link class="tp-btn-h1" to="/my-orders">Back</router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
    </div>
     
    
  </div>
  <!-- cta area start -->
  <cta-area></cta-area>
    <!-- cta area end -->
</template>



<script>
import CtaArea from '@/components/cta/cta-area.vue'
export default {
  name: 'OrderDetails',
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  components: {
    CtaArea,
  },
  data() {
    return {
      order: null,
      orderItems: [],
      loading: true,
      error: null,
    };
  },
  methods: {
    async fetchOrderDetails() {
      try {
        // Replace with your API endpoint
        const response = await this.$axios(`/orders/${this.id}`);
        this.order = response.data;
      } catch (err) {
        this.error = 'Failed to load order details.';
      } finally {
        this.loading = false;
      }
    },
    async fetchOrderItemDetails() {
      try {
        // Replace with your API endpoint
        const response = await this.$axios(`order-items/by-order/${this.id}`);
        this.orderItems = response.data;
      } catch (err) {
        this.error = 'Failed to load order details.';
      } finally {
        this.loading = false;
      }
    },
    formatDate(date) {
      const options = { year: 'numeric', month: 'long', day: 'numeric' };
      return new Date(date).toLocaleDateString(undefined, options);
    },
  },
  mounted() {
    this.fetchOrderDetails();
    this.fetchOrderItemDetails();
  },
};
</script>

<style scoped>
.order-details {
  padding: 20px;
  max-width: 800px;
  margin: 0 auto;
}

.error {
  color: red;
}
.tp-btn-h1{
  background: #f03723;
}
</style>